import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as Yup from "yup";
import { jwtDecode } from 'jwt-decode';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'
import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik';
import { Modal } from 'react-bootstrap';
import { BiLock, BiUser } from 'react-icons/bi';
import * as jnb from "react-bootstrap";
import { ERROR_MSG } from '../CommonUtils/Validations/RegularExpAndVar';
import { FaEye, FaEyeSlash, FaTimes } from 'react-icons/fa';
import axios from 'axios';
import { config } from '../CommonUtils/CommonUrl/CommonUrls';
import Sweetalert from '../CommonUtils/CommonPopupAndAlerts/SweetAlerts';
import preval from "preval.macro";

function LoginPage() {
  const hostname = window.location.hostname
  const ENVData = process.env.NODE_ENV === 'development' ? "local" : hostname === 'boc.dev.nidhi.apcfss.in' ? "dev" : "sdc";
  const [show, setShow] = useState(false);
  const [showcaptcha, setCaptcha] = useState();
  // const [CaptchId, setCaptchaId] = useState();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const userValidationSchema = Yup.object().shape({
    username: Yup.string().required(ERROR_MSG),
    password: Yup.string().required(ERROR_MSG),
    userInput: Yup.string().required(ERROR_MSG),
  });
  const submitDetails = async (values) => {
    values.username = values.username.trim()
    values.password = values.password.trim()
    values.userInput = values.userInput.trim()
    values.captchaId = showcaptcha?.captchaId
    //CommonPost.submitLoginPage(values).then((res) => {
    axios.post(config.url.BOC_URL + "auth/authenticate", values, { withCredentials: true }).then((res) => {

      //console.log(res.data);
      if (res.data.scode === "01") {
        //  GetDistricts()
        var decoded = jwtDecode(res.data.access_token);
        var decoded_refresh = jwtDecode(res.data.refresh_token);
        var date = new Date(decoded.exp * 1000);
        //var iat = new Date(decoded.iat * 1000); // issued at compare exp and iat to know token time
        var ref_date = new Date(decoded_refresh.exp * 1000);
        let token = res.data.access_token
        Cookies.set("jwtToken", token, { expires: date });
        Cookies.set("jwtRefreshToken", res.data.refresh_token, { expires: ref_date });

        //     localStorage.setItem("jwtToken",token)
        // localStorage.setItem("jwtRefreshToken", res.data.refresh_token)

        //   Cookies.set("jwtToken", res.data.access_token, {
        //   expires: date, // OR expires: 1 for 1 day
        //   secure: false,
        //   sameSite: "Strict",
        //   path: "/",
        // });

        // Cookies.set("jwtRefreshToken", res.data.refresh_token, {
        //   expires: ref_date,
        //   secure: false,
        //   sameSite: "Strict",
        //   path: "/",
        // });

        dispatch({
          type: "SHOW_LOGIN_DETAILS",
          payload: {
            isLoggedIn: true,
            loginData: decoded,
            userType: res.data.user_type

          }
        })
        console.log("first>>>>>>>>>>>", decoded)
        if (res.data.user_type === "user") {
          navigate("/DashBoardMain")
        }
        else if (res.data.user_type === "emp") {
          navigate("/Dashboard")
        }
      }
      else if (res.data.sdesc === "Invalid Captcha") {
        Sweetalert(res.data.sdesc, 'error').then((result) => {
          if (result.isConfirmed) {
            formIk.setFieldValue("userInput", "");
            // CaptchaEntry()
          }
        });
      }
      else {
        Sweetalert(res.data.sdesc, 'error').then(() => {
          formIk.setFieldValue("password", "")
          formIk.setFieldValue("username", "")
          formIk.setFieldValue("userInput", "");
          // CaptchaEntry()
        });
      }
    })
  }

  // function CaptchaEntry() {
  //   axios.get(config?.url?.BOC_URL + "captcha").then((res) => {
  //     if (res.data.scode === '01') {
  //       setCaptcha({
  //         url: res?.data?.sdesc,
  //         captchaId: res?.data?.captchaId
  //       });
  //     }
  //   })
  // }

  // useEffect(() => { CaptchaEntry() }, [])
  //   const submitDetails = async (values, req) => {
  //   try {

  //     values.username = values.username.trim();
  //     values.password = values.password.trim();

  //     const res = await axios.post(config.url.BOC_URL + "auth/authenticate", req, {
  //       withCredentials: true,
  //     });

  //     if (res.data.scode === "01") {
  //       const decoded = jwtDecode(res.data.access_token);
  //       const decoded_refresh = jwtDecode(res.data.refresh_token);

  //       const expDate = new Date(decoded.exp * 1000);
  //       const refreshExpDate = new Date(decoded_refresh.exp * 1000);


  //       localStorage.setItem("jwtToken", res.data.access_token);
  //       localStorage.setItem("jwtRefreshToken", res.data.refresh_token);


  //       dispatch({
  //         type: "SHOW_LOGIN_DETAILS",
  //         payload: {
  //           isLoggedIn: true,
  //           loginData: decoded,
  //           userType: res.data.user_type,
  //         },
  //       });

  //       console.log("Decoded token:", decoded);


  //       if (res.data.user_type === "user") {
  //         navigate("/DashBoardMain");
  //       } else if (res.data.user_type === "emp") {
  //         navigate("/Dashboard");
  //       }
  //     } else {
  //       alert(res.data.sdesc || "Login failed");
  //     }
  //   } catch (error) {
  //     console.error("Login error:", error);
  //     alert("An error occurred during login. Please try again.");
  //   }
  // };
  const formIk = useFormik({
    initialValues: {
      username: "",
      password: "",
      userInput: "",
      captchaId: "",
    },
    validationSchema: userValidationSchema,
    onSubmit: submitDetails,
  });



  function payment() {
    try {
      axios.get(config.url.BOC_URL + "boc-public/test")
        .then((response) => {
          console.log("Response: ", response);
          let resData = response.data.encrypted_string;
          let merchantId = response.data.merchant_id;
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = "https://test.epay.sbiuat.bank.in/secure/AggregatorHostedListener";
          // form.action = "https://epay.sbi.bank.in/secure/AggregatorHostedListener";

          const inputMerchantId = document.createElement('input');
          inputMerchantId.type = 'hidden';
          inputMerchantId.name = 'merchIdVal';
          inputMerchantId.id = 'merchIdVal';
          inputMerchantId.value = merchantId;
          form.appendChild(inputMerchantId);
          const inputEncryption = document.createElement('input');
          inputEncryption.type = 'hidden';
          inputEncryption.name = 'EncryptTrans';
          inputEncryption.id = 'EncryptTrans';
          inputEncryption.value = resData;
          form.appendChild(inputEncryption);
          document.body.appendChild(form);
          form.submit();
        })
        .catch((error) => {
          console.log("Error during API request:", error);
        });
    } catch (error) {
      console.log("Unexpected error during payment setup:", error);
    }
  }


  function paymentProd() {
    try {
      axios.get(config.url.BOC_URL + "boc-public/test_prod")
        .then((response) => {
          console.log("Response: ", response);
          let resData = response.data.encrypted_string;
          let merchantId = response.data.merchant_id;
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = "https://epay.sbi.bank.in/secure/AggregatorHostedListener";
          const inputMerchantId = document.createElement('input');
          inputMerchantId.type = 'hidden';
          inputMerchantId.name = 'merchIdVal';
          inputMerchantId.id = 'merchIdVal';
          inputMerchantId.value = merchantId;
          form.appendChild(inputMerchantId);
          const inputEncryption = document.createElement('input');
          inputEncryption.type = 'hidden';
          inputEncryption.name = 'EncryptTrans';
          inputEncryption.id = 'EncryptTrans';
          inputEncryption.value = resData;
          form.appendChild(inputEncryption);
          document.body.appendChild(form);
          form.submit();
        })
        .catch((error) => {
          console.log("Error during API request:", error);
        });
    } catch (error) {
      console.log("Unexpected error during payment setup:", error);
    }
  }
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div>
      <section id="logo-section">
        <div className="container-fluid">
          <div className="row py-2">
            <div className="col-xxl-1 col-xl-1 col-lg-1 col-md-2 col-sm-12 col-xs-12">
              <div className="logo-image text-center">
                <img src="../images/logo.png" className="img-fluid" style={{ width: '85px' }} />
              </div>
            </div>
            <div className="col-xxl-11 col-xl-11 col-lg-11 col-md-10 col-sm-12 col-xs-12">
              <div className="logo-text mt-lg-3 mt-md-4 mt-3">
                <h3>&#3078;&#3074;&#3111;&#3149;&#3120;&#3114;&#3149;&#3120;&#3110;&#3143;&#3126;&#3149; &#3117;&#3125;&#3112; &#3118;&#3120;&#3135;&#3119;&#3137; &#3079;&#3108;&#3120; &#3112;&#3135;&#3120;&#3149;&#3118;&#3134;&#3107; &#3093;&#3134;&#3120;&#3149;&#3118;&#3135;&#3093;&#3137;&#3122; &#3128;&#3074;&#3093;&#3149;&#3127;&#3143;&#3118; &#3116;&#3147;&#3120;&#3149;&#3105;&#3137;</h3>
                <h3>Andhra Pradesh Building and Other Construction Workers Welfare Board</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-------------------------------------------NAVBAR----------------------------------------------> */}
      <section id="navbar-section">
        <div className="container px-0">
          <nav className="navbar navbar-expand-lg">
            <div className="container">
              <button className="navbar-toggler border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                  <li className="nav-item">
                    <a className="nav-link" >Home</a>
                  </li>
                  {/* <li className="nav-item">
                <a className="nav-link" href="#" target="_blank"><img src="../images/new.gif" /> CESS Payment Module</a>
              </li> */}
                  <li className="nav-item">
                    <a className="nav-link" >Worker Registration</a>
                  </li>
                  <li className="nav-item">
                    {/* <a className="nav-link" href="#" target="_blank"><img src="../images/new.gif" /> Establishment Registration</a> */}
                  </li>
                  {/* <li className="nav-item">
                <a className="nav-link" data-bs-toggle="modal" data-bs-target="#exampleModal">Instructions</a>
              </li> */}
                  {/* <!-- <li className="nav-item">
                <a className="nav-link" data-bs-toggle="modal" data-bs-target="#exampleModal">Application Status</a>
              </li> --> */}
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="modal" data-bs-target="#exampleModal">Downloads</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link">
                      Reports
                    </a>
                  </li>
                  {/* <!-- <li className="nav-item">
                <a className="nav-link" data-bs-toggle="modal" data-bs-target="#exampleModal">GOs</a>
              </li> --> */}
                  <li className="nav-item">
                    <a className="nav-link" 


                    >Contact Us</a>
                  </li>
                </ul>
                {/* <button
                  className="btnn button-loginn" type="submit" onClick={() => { setShow(true); }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-box-arrow-in-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z" />
                    <path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z" />
                  </svg>
                  Login</button> */}
              </div>
            </div>
          </nav>
        </div>
      </section>


      {/* <!-------------------------------------------SLIDER AND WHATS NEW----------------------------------------------> */}
      <section id="slider">
        <div className="container">
          <div className="row pt-3">
            <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 px-0">
              <div id="demo" className="carousel slide" data-bs-ride="carousel">

                {/* <!-- Indicators/dots --> */}
                <div className="carousel-indicators">
                  <button type="button" data-bs-target="#demo" data-bs-slide-to="0" className="active"></button>
                  <button type="button" data-bs-target="#demo" data-bs-slide-to="1"></button>

                </div>

                {/* <!-- The slideshow/carousel --> */}
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img src="../images/slide1.png" alt="Los Angeles" className="d-block slide-1 img-fluid" style={{ width: "100%", height: "380px" }} />
                  </div>
                  <div className="carousel-item">
                    <img src="../images/slide2.png" alt="Chicago" className="d-block slide-1 img-fluid" style={{ width: "100%", height: "380px" }} />
                  </div>

                </div>
                {/* <!-- Left and right controls/icons --> */}
                <button className="carousel-control-prev" type="button" data-bs-target="#demo" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon"></span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#demo" data-bs-slide="next">
                  <span className="carousel-control-next-icon"></span>
                </button>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12" style={{ background: "#121247" }}>
              <div className="three"><h3>What’s New</h3></div>

              <marquee behavior="scroll" scrolldelay="200" direction="up" onmouseover="this.stop();" onmouseout="this.start();" height="205px;" style={{ color: "#ffffff", fontSize: "13px", lineHeight: "1.4" }} >
                <div className="notifications">
                  {/* <p className="mt-2"><a href="#" target="_blank"><img src="../images/new.gif" /> CESS Payment Module</a></p> */}
                  <p className="mt-2"><a href="#" target="_blank"><img src="../images/new.gif" /> welcome to Andhra Pradesh Building and Other Construction Workers Welfare Board</a></p>
                </div>
              </marquee>
            </div>
          </div>
        </div>
      </section>

      {/* <!-------------------------------------------LATEST NEWS----------------------------------------------> */}
      <section id="morque">
        <div className="container">
          <div className="">
            <div className="row latest my-4 d-flex">

              <div className="col-lg-2 col-md-2 col-sm-2 col-3 latesttext text-center pt-3 ">
                <h3>Latest News</h3>
              </div>
              <div className=" col-lg-10 col-md-12 col-sm-10 col-9 scrolltext pt-3">

                <marquee direction="left">
                  <a href="#"><img src="../images/new.gif" /> welcome to Andhra Pradesh Building and Other Construction Workers Welfare Board</a>
                </marquee>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-------------------------------------------ABOUT US----------------------------------------------> */}
      <section id="about">
        <div className="container">
          <div className="row about-row">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
              <div className="about-headding">
                <h3>About Us</h3>
                <p className="mt-4"><strong>The Andhra Pradesh Building & Other Construction Workers Welfare
                  Board</strong> was established by the Government of Andhra Pradesh under Section 18 of
                  Building & Other Construction Workers (RE&CS) Act, 1996 primarily for formulating
                  and implementing the various Welfare schemes for the benefit of the Building & Other
                  Construction Workers in the Andhra Pradesh. The Board has come into existence with
                  effect from 30-04-2007.</p>

                <p>The Andhra Pradesh Building & Other Construction Workers Welfare Board is a tripartite body
                  consisting of worker representatives, employer representatives and Government officials.
                  The Board has carried on extensive drives and registered more than 20 lakhs construction
                  workers as beneficiaries and also formulated and have been implementing various schemes
                  such as marriage gift, Maternity Benefit, Fatal Accident Relief, Disability Relief, Natural
                  Death Relief, Hospitalisation relief, Funeral Expenses and Pension Scheme (NPS).</p>
                {/* <!-- <button type="button" className="btn button-login1">View More</button>     --> */}
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 my-auto pe-0">
              {/* <div className="cm-images-part text-center">
                 <img src="../images/cm.png" className="img-fluid"/>
                 <p className="cm-name mt-2">Sri. Y.S.Jagan Mohan Reddy</p>
                 <p className="name-title">Hon’ble Chief Minister</p>
              </div>
             </div>
             <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 my-auto">
                 <div className="min-images-part text-center">
                     <img src="../images/min.png" className="img-fluid"/>
                     <p className="cm-name mt-2">Sri. Gummanur Jayaram</p>
                     <p className="name-title">Hon’ble Minister for Labour & Employment, Training & Factories. </p>
                  </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* <!-------------------------------------------CM,MINISTER IMAGES AND DASH BOARD----------------------------------------------> */}
      <section id="dash-board">
        <div className="container">
          <div className="row my-20 border">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div className="about-images text-center">
                <img src="../images/about-image.svg" className="img-fluid my-lg-3 my-md-4 my-3" />
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 dash-board-box-1">
                  <div className="dash-board-box-text text-center">
                    <img src="../images/icon1.png" className="img-fluid" width="80" height="80" />
                    <p className="numbers mt-3">-</p>
                    <p className="dasg-text">Total Registrations</p>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 dash-board-box-2">
                  <div className="dash-board-box-text text-center">
                    <img src="../images/icon2.png" className="img-fluid" width="80" height="80" />
                    <p className="numbers mt-3">-</p>
                    <p className="dasg-text">Registrations</p>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 dash-board-box-3">
                  <div className="dash-board-box-text text-center">
                    <img src="../images/icon3.png" className="img-fluid" width="80" height="80" />
                    <p className="numbers mt-3">-</p>
                    <p className="dasg-text">Workers</p>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 dash-board-box-4">
                  <div className="dash-board-box-text text-center">
                    <img src="../images/icon4.png" className="img-fluid" width="80" height="80" />
                    <p className="numbers mt-3">-</p>
                    <p className="dasg-text">Linked Workers</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-------------------------------------------FOOTER----------------------------------------------> */}
      <section id="footer">
        <div className="container">
          <div className="row footer-row">
            {/* <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
              <div className="Related-Links">
                <h3 className="mb-3">Related Links</h3>
                <div className="footer-links mb-2">
                  <a className="links" onClick={() => navigate("https://www.india.gov.in/")} target="_blank" style={{ color: "#fff", textDecoration: "none" }}>https://www.india.gov.in/</a>
                </div>
                <div className="footer-links">
                  <a className="links" onClick={() => navigate("https://labour.ap.gov.in/")} target="_blank" style={{ color: "#fff", textDecoration: "none" }}>Labour Department</a>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 ">
              <div className="Contact-Us">
                <h3 className="mb-3">Contact Us</h3>
                <div className="footer-middle-part">
                  <div className="d-flex">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-telephone" viewBox="0 0 16 16">
                      <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                    </svg>
                    <p className="ms-2">8688256467</p>
                  </div>
                  <div className="d-flex">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-envelope" viewBox="0 0 16 16">
                      <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
                    </svg>
                    <p className="ms-2 bieap1819"> itcell.aplabour@gmail.com</p>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
              <div className="map">
                <div className="col-xxl-6 col-xl-6 col-lg-4 col-md-12 col-sm-12 col-xs-12 ">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d979261.5006965976!2d80.639976!3d16.513965!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35e55338e3cb75%3A0xaf97a529c9e43b1c!2sOffice%20Of%20The%20Commissioner%20Of%20Labour%2C%20Goverment%20Of%20Andhra%20Pradesh!5e0!3m2!1sen!2sin!4v1747723488167!5m2!1sen!2sin" width="100%" height="265" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>
            </div> */}
            <div className="footer-row">
              {/* Related Links */}
              <div className="footer-col">
                <h3>Related Links</h3>
                <p>
                  <a href="https://www.india.gov.in/" target="_blank" rel="noreferrer">
                    https://www.india.gov.in/
                  </a>
                </p>
                <p>
                  <a href="https://labour.ap.gov.in/" target="_blank" rel="noreferrer">
                    Labour Department
                  </a>
                </p>
                <p>
                  <a href="https://boc.ap.gov.in/RefundandCancellationPolicy" target="_blank" rel="noreferrer">
                    Refund & Cancellation Policy
                  </a>
                </p>
              </div>

              {/* Contact Us */}
              <div className="footer-col justify-content-right">
                <h3>Contact Us</h3>
                <p>📞 8688256467</p>
                {/* <p>📧 itcell.aplabour@gmail.com</p> */}
              </div>

              {/* Google Map */}
              {/* <div className="footer-col">
                <iframe
                  title="location"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d979261.5006965976!2d80.639976!3d16.513965!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a35e55338e3cb75%3A0xaf97a529c9e43b1c!2sOffice%20Of%20The%20Commissioner%20Of%20Labour%2C%20Goverment%20Of%20Andhra%20Pradesh!5e0!3m2!1sen!2sin!4v1747723488167!5m2!1sen!2sin"
                  width="100%"
                  height="180"
                  loading="lazy"
                ></iframe>
              </div> */}
            </div>
            {/* Bottom Section */}
            <div className="footer-bottom">
              <p>Site last updated(build) on:{" "}
                {preval`module.exports = new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' });`}
              </p>
              <p>Env : {ENVData}</p>


              <p>
                This site is best viewed in 1024 × 768 resolution with the latest version of Chrome, Firefox, Safari, and Internet Explorer.
              </p>

              <p className="visitor-title">Visitors Count</p>
              <img
                src="https://counter5.optistats.ovh/private/freecounterstat.php?c=8mrxm7hqmytx45yubxrr1mqmz6l33b7l"
                alt="visitor counter"
              />

              {/* <p>Active Sessions: --</p> */}

              <p className="copy">© 2017 AP Building and Other Construction Workers Welfare Board</p>
              {/* <p className="copy">Designed & Developed by APCFSS</p> */}
            </div>

          </div>
        </div>
      </section>
      <Modal show={show} onHide={() => setShow(false)} dialogclassNameName="custom-modal" backdrop="static">
        <Modal.Header classNameName="border-0">
          <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'flex-end', width: "100%" }}>
            <button className="custom-close-btn" onClick={() => setShow(false)}>
              <FaTimes size={20} />
            </button>
          </div>
        </Modal.Header>

        <Modal.Body>
          <jnb.Row className="justify-content-center">
            <jnb.Col xs={12} sm={12} md={12} lg={9} xl={9} xxl={9}></jnb.Col>

            <jnb.Col xs={12} sm={12} md={12} lg={9} xl={9} xxl={9}>
              <FormikProvider value={formIk}>
                <form
                  onChange={formIk.handleChange}
                  onSubmit={formIk.handleSubmit}
                  className="form_adjust"
                >
                  <div className="inner-herbpage-service-title-sub">
                    <h1 style={{ fontSize: "30px" }}>Login</h1>
                  </div>

                  <jnb.InputGroup className="mb-3">
                    <jnb.InputGroup.Text id="basic-addon1" className="group_txt">
                      <BiUser className="font_size" />
                    </jnb.InputGroup.Text>
                    <Field
                      type="text"
                      name="username"
                      placeholder="Enter Your User Name"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="username"
                      component="div"
                      className="text-error"
                    />
                  </jnb.InputGroup>
                  <div style={{ position: "relative", width: "100%" }}>
                    <jnb.InputGroup className="mb-3">

                      <jnb.InputGroup.Text id="basic-addon2" className="group_txt">
                        <BiLock className="font_size" />
                      </jnb.InputGroup.Text>
                      <Field
                        placeholder="password"
                        name="password"
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        autoComplete="off"
                      />
                      <span
                        onClick={() => setShowPassword(!showPassword)}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#666",
                        }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>

                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-error"
                      />
                    </jnb.InputGroup>
                    <jnb.InputGroup className="mb-3">
                      <jnb.InputGroup.Text id="basic-addon2" className="group_txt">
                        <img src={showcaptcha?.url} alt="Captcha Image" width='100%' height='100%' style={{ userSelect: 'none', pointerEvents: 'none' }} />
                      </jnb.InputGroup.Text>
                      <input placeholder=" Enter The Captcha" name="userInput" type="text" value={formIk.values.userInput}
                        aria-label="Password"
                        onKeyUp={(e) => { formIk.setFieldValue("userInput", e.target.value.toUpperCase()) }}
                        aria-describedby="basic-addon1"
                        className="form-control" autoComplete="off" />
                      <ErrorMessage name="userInput" className="text-error" component="div" />
                    </jnb.InputGroup>
                  </div>

                  <div className="d-grid gap-2">
                    <jnb.Button variant="success" type="submit" className="btn_primary">
                      Sign in
                    </jnb.Button>
                    <a onClick={() => navigate("/registrationform")} className="text-end text-black forgot">
                      New registration
                    </a>
                    <a
                      onClick={() => navigate("/Forgotpassword")}
                      className="text-right text-black forgot mb-6"
                      style={{ zIndex: "9994" }}
                    >
                      Forgot Password?
                    </a>
                  </div>
                </form>
              </FormikProvider>
            </jnb.Col>

            <jnb.Col xs={12} sm={12} md={12} lg={9} xl={9} xxl={9}></jnb.Col>
          </jnb.Row>

        </Modal.Body>


      </Modal>
      {/* <!-------------------------------------------BRAND APCFSS----------------------------------------------> */}
      <section id="brand-part">
        <div className="container">
          <div className="row mx-0">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-1">
              <div className="Copyright">
                <p>© Copyright 2017 AP Building and Other Construction Workers Welfare Board</p>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mt-1">
              <div className="apcfss d-flex">
                <p>Designed and Developed by</p>
                <img src="../images/apcfss.svg" className="img-fluid" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js" integrity="sha384-geWF76RCwLtnZ8qwWowPQNguL3RmwHVBC9FhGdlKrxdiJJigb/j/68SIy3Te4Bkz" crossorigin="anonymous"></script>
      {/* <!-- Modal --> */}
      <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            {/* <!-- <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">Modal title</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div> --> */}
            <div className="modal-body">
              <p className="fs-2 fw-bold">Will Be Available Soon</p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">OK</button>
              {/* <!-- <button type="button" className="btn btn-primary">Save changes</button> --> */}
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default LoginPage;

